import { render, staticRenderFns } from "./ManualSeoList.vue?vue&type=template&id=037382c9&scoped=true&"
import script from "./ManualSeoList.vue?vue&type=script&lang=js&"
export * from "./ManualSeoList.vue?vue&type=script&lang=js&"
import style0 from "./ManualSeoList.vue?vue&type=style&index=0&id=037382c9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037382c9",
  null
  
)

export default component.exports